<template>
  <div class="modal-content-wrap">
    <div class="lego-text-field-wrapper" style="width: 100%">
      <lego-text-field
        ref="input"
        searchable
        v-model="tmpText"
        counter="100"
        :isCounter="false"
        :placeholder="getPlaceHolder"
        @click-icon="searchFields"
        @enter="searchFields"
      />
    </div>

    <AddMonitorTargetSubItem
      v-if="isExistSubItem"
      ref="subItem"
      :searchText="textSearch"
      :monitorInfo="monitorInfo"
      :objectTypeName="objectTypeName"
      :selectMaxItem="selectMaxItem"
      @onCheck="onCheck"
      :scrollMaxRow="13"
      :height="480"
      @clearSearchText="clearSearchText"
      class="add-moni-target-sub-item"
    />
    <AddMonitorTargetItem
      v-else
      ref="monTargetItem"
      :selected="selected"
      :searchText="textSearch"
      :monitorInfo="monitorInfo"
      :scrollMaxRow="13.8"
      :height="500"
      :isSelectAsg="isSelectAsg"
      :selectMaxItem="selectMaxItem"
      @onCheck="onCheck"
      @clearSearchText="clearSearchText"
    />
  </div>
</template>
<script>
import { checkObjectTypesNonSub } from '@/containers/utils/utils.js';
import AddMonitorTargetItem from '@/containers/performance/AddMonitorTargetItem.vue';
import AddMonitorTargetSubItem from '@/containers/performance/AddMonitorTargetSubItem.vue';
import validateSearchMixin from '@/mixins/validateSearch.mixin';

export default {
  name: 'AddMonitorTarget',
  emits: ['selected-list'],
  mixins: [validateSearchMixin],
  props: {
    monitorInfo: {
      type: Object,
      default: () => {
        return {
          pProductTypeCode: '',
          pProductTypeName: '',
          pProductTypeCodes: [],
          pObjectTypeCode: '',
          pObjectTypeName: ''
        };
      }
    },
    selectMaxItem: {
      type: Number,
      default: 10
    },
    selected: {
      type: Array,
      default: () => []
    },
    isSelectAsg: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AddMonitorTargetItem,
    AddMonitorTargetSubItem
  },
  computed: {
    isExistSubItem() {
      let { pProductTypeCode, pObjectTypeCode } = this.monitorInfo;
      return checkObjectTypesNonSub(pProductTypeCode, pObjectTypeCode);
    },
    getPlaceHolder() {
      return this.monitorInfo.pProductTypeCode === 'WAN'
        ? this.$t('searchLabel.searchLike', { VPC: this.$t('searchLabel.attachmentName') })
        : this.$t('searchLabel.searchLike', { VPC: this.$t('searchLabel.monTarget') });
    }
  },
  data() {
    return {
      objectTypeCode: '',
      tmpText: '',
      objectTypeList: [],
      allCardList: [],
      objectTypeName: '',
      textSearch: ''
    };
  },
  created() {
    this.popupInit();
  },
  methods: {
    async popupInit() {
      if (this.monitorInfo.pObjectTypeCode) {
        this.objectTypeCode = this.monitorInfo.pObjectTypeCode;
        this.objectTypeList = await this.$http.product.getListProductObjectTypes(
          this.monitorInfo.pProductTypeCode
        );
        this.objectTypeName = this.objectTypeList.find(
          (o) => o.value === this.objectTypeCode
        )?.text;
      }
    },
    mutateProductName(value) {
      return value.replace(this.$const.NOT_ALLOWED_REGEX.MORNITORING_NAME, '');
    },
    deleteCard(delType, item) {
      if (this.isExistSubItem) {
        this.$refs.subItem.deleteCard(item);
      }
    },
    onCheck(selectedItems) {
      this.allCardList = selectedItems;
      this.$emit('selected-list', selectedItems);
    },
    searchFields() {
      this.textSearch = this.tmpText;
      if (this.$refs.monTargetItem) {
        this.$refs.monTargetItem.execSearch(true, this.textSearch);
      }

      this.$refs.input.blur();
    },
    resetSearchField() {
      this.tmpText = '';
      this.textSearch = '';
      if (this.$refs.monTargetItem) {
        this.$refs.monTargetItem.execSearch(true);
      }
    },
    execSearch() {
      if (this.$refs.monTargetItem) {
        this.$refs.monTargetItem.execSearch();
      }
    },
    clearSearchText() {
      this.tmpText = '';
      this.textSearch = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.lego-select-search {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.lego-text-field-wrapper {
  display: inline-block;
}

.badge-text-wrapper {
  display: flex;
  align-items: center;
}

:deep .listTargetItem {
  display: inline-block;
  color: #364fc7;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

:deep .scpmSubTitleContainer .scpmSubTitle {
  font-size: 14px !important;
}

.scpm-drag-wrap {
  padding-top: 20px;
}

:deep .added-list-box {
  margin-top: 5px !important;
}
.modal-content-wrap {
  height: 100%;
}
</style>
